import Telephone from './Telephone';

export default Telephone;
